import { strings } from 'strings';
import * as yup from 'yup';
import { InferType } from 'yup';

import { resolutionStringValidator } from '../../../../../../../validations/string';

export const coloringGridFormSchema = yup.object({
  id: yup.string().optional(),

  image: yup.string().required(strings.coloringGrid.form.errors.image.required),
  imageResolution: resolutionStringValidator().required(),
  name: yup.string().trim().required(strings.coloringGrid.form.errors.name.required),
  publisher: yup
    .object({
      label: yup.object(),
      value: yup.string().required(strings.coloringGrid.form.errors.publisher.required),
    })
    .typeError(strings.coloringGrid.form.errors.publisher.required)
    .required(strings.coloringGrid.form.errors.publisher.required),
  status: yup
    .object({
      label: yup.string(),
      value: yup.string().required(strings.coloringGrid.form.errors.status.required),
    })
    .typeError(strings.coloringGrid.form.errors.status.required)
    .required(strings.coloringGrid.form.errors.status.required),
  premiumTier: yup
    .object({
      label: yup.string(),
      value: yup.number().required(strings.coloringGrid.form.errors.price.required),
    })
    .typeError(strings.coloringGrid.form.errors.price.required)
    .required(strings.coloringGrid.form.errors.price.required),
  keywords: yup.string().trim().required(strings.coloringGrid.form.errors.keywords.required),
  aiGenerated: yup.boolean(),
  forceSetPublishDate: yup.boolean(),
  collections: yup
    .array()
    .of(
      yup.object({
        label: yup.string(),
        value: yup.string(),
      }),
    )
    .required(strings.coloringGrid.form.errors.collections.required)
    .min(1, strings.coloringGrid.form.errors.collections.minimum),
});

export type ColoringGridField = InferType<typeof coloringGridFormSchema>;
